import Select, { components, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";

interface UserOption {
  value: string;
  label: string;
  pictureUrl: string;
}

interface SelectDropdownProps {
  selectedValue: any;
  onValueChanged: (value: any) => void;
  onInputChanged?: (value: any) => void;
  isDisabled: boolean;
  list: any[];
  customOption?: any | null;
  customValue?: any | null;
  isMulti?: boolean | null;
  placeholder?: string | null;
  className?: string;
}

const SelectDropdown = ({ selectedValue, onValueChanged, isDisabled, list, customOption, customValue, onInputChanged, className, isMulti = false, placeholder = "เลือก..." }: SelectDropdownProps) => {
  const CustomDropdownIndicator = (props: DropdownIndicatorProps<UserOption>) => {
    if (props.isDisabled) {
      return null; // 👈 hide arrow when disabled
    }

    return <components.DropdownIndicator {...props} />;
  };
  const CustomIndicatorSeparator = (props: IndicatorSeparatorProps<UserOption>) => {
    if (props.isDisabled) {
      return null; // 👈 hide arrow when disabled
    }

    return <components.IndicatorSeparator {...props} />;
  };

  return (
    <>
      <Select
        options={list}
        styles={Utils.GetThemeForReactSelect()}
        isClearable={true}
        isDisabled={isDisabled}
        components={{
          Option: customOption ?? components.Option,
          SingleValue: customValue ?? components.SingleValue,
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: CustomIndicatorSeparator,
        }}
        value={selectedValue}
        onChange={(e: any) => { /*console.log('select change:', e);*/ isMulti ? onValueChanged(e) : onValueChanged(e?.value ?? null); }}
        isMulti={isMulti ? true : false}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={document.body}
        placeholder={placeholder}
        onInputChange={onInputChanged}
        className={className}
      />
    </>
  )
}

export default SelectDropdown

